import React, { useState, useEffect } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import PendingRequests from "./PendingRequests";
import RequestHistory from "./RequestHistory";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";

export default function AllTabOrderRequests({ postcounts }) {
  const path = "Assets/scss/myorders.module.scss";
  const [activeTab, setActiveTab] = useState("Pendingrequests");
  const { urlstate, setReceivedOrderRequestroute } = useRouteBaseStateContext();


  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setReceivedOrderRequestroute(tab);
  };

  useEffect(() => {
    if (urlstate?.receivedorderrouterequest) {
      setActiveTab(urlstate?.receivedorderrouterequest || "Pendingrequests");
    } else {
      setActiveTab("Pendingrequests");
    }
  }, [urlstate, urlstate?.receivedorderrouterequest]);
  const prc =
    (Number(postcounts?.bxp) || 0) +
    (Number(postcounts?.sale) || 0) +
    (Number(postcounts?.rental) || 0);

  const rhc =
    (Number(postcounts?.bxp_history) || 0) +
    (Number(postcounts?.sale_history) || 0) +
    (Number(postcounts?.rental_history) || 0);

  return (
    <div className="order-tabs">
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <a
            
            className={`nav-link ${activeTab == "Pendingrequests" ? "active" : ""}`}
            onClick={() => handleTabChange("Pendingrequests")}
          >
            Pending requests ({prc || 0})
          </a>
        </li>
        <li className="nav-item">
          <a
            
            className={`nav-link ${activeTab == "Requesthistory" ? "active" : ""}`}
            onClick={() => handleTabChange("Requesthistory")}
          >
            Declined request history ({rhc || 0})
          </a>
        </li>
      </ul>
      <div className="tab-content">
        {activeTab == "Pendingrequests" && <PendingRequests count={postcounts} />}
        {activeTab == "Requesthistory" && <RequestHistory count={postcounts} />}
      </div>
    </div>
  );
}
